import type { ReactNode } from "react";
import { _ } from "i18n";
import { DatagridFilters } from "../../../../datagrid/DatagridFilters";
import type { FilterConfig } from "../../../../datagrid-configs/types";
import type { ColumnVisibility, FilterValues } from "../../../../datagrid-configs/types";

export interface DiscoverGamesToolbarProps {
	filtersCollapsed: boolean;
	discoverGamesFilters: FilterConfig[];
	filterValues: FilterValues;
	onFilterChange: (values: FilterValues) => void;
	onClearFilters: () => void;
	onToggleFiltersCollapse: () => void;
	dynamicOptions: Record<string, Array<{ value: string | number; label: string }>>;
	visibleColumns: ColumnVisibility;
	bulkUpdateButton: ReactNode;
	onOpenColumnModal: () => void;
	selectedViewName: string | null;
	programGameButton: ReactNode;
}

export function DiscoverGamesToolbar({
	filtersCollapsed,
	discoverGamesFilters,
	filterValues,
	onFilterChange,
	onClearFilters,
	onToggleFiltersCollapse,
	dynamicOptions,
	visibleColumns,
	bulkUpdateButton,
	onOpenColumnModal,
	selectedViewName,
	programGameButton,
}: DiscoverGamesToolbarProps) {
	const filterPanel = (
		<DatagridFilters
			filters={discoverGamesFilters}
			filterValues={filterValues}
			onFilterChange={onFilterChange}
			onClear={onClearFilters}
			isCollapsed={filtersCollapsed}
			onToggleCollapse={onToggleFiltersCollapse}
			dynamicOptions={dynamicOptions}
			columnVisibility={visibleColumns}
		/>
	);

	const actionButtons = (
		<>
			{bulkUpdateButton}
			<button
				type="button"
				className="discoverGamesTableV3-columnBtn"
				onClick={onOpenColumnModal}
				title={_("discover.gamesTable.columnVisibility.title")}
			>
				<svg
					width="16"
					height="16"
					viewBox="0 0 16 16"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
				>
					<path
						d="M2 4h12M2 8h12M2 12h12"
						stroke="currentColor"
						strokeWidth="1.5"
						strokeLinecap="round"
					/>
					<circle cx="5" cy="4" r="1.5" fill="currentColor" />
					<circle cx="11" cy="8" r="1.5" fill="currentColor" />
					<circle cx="7" cy="12" r="1.5" fill="currentColor" />
				</svg>
				{_("discover.gamesTable.columnVisibility.label")}
				{selectedViewName && (
					<span className="discoverGamesTableV3-viewBadge">{selectedViewName}</span>
				)}
			</button>
			{programGameButton}
		</>
	);

	return (
		<div className={`discoverGamesTableV3-header ${filtersCollapsed ? "filters-collapsed" : ""}`}>
			{!filtersCollapsed && (
				<div className="discoverGamesTableV3-headerTop">
					<div className="discoverGamesTableV3-headerLeft">{filterPanel}</div>
				</div>
			)}

			{filtersCollapsed && (
				<div className="discoverGamesTableV3-headerSingleRow">
					<div className="discoverGamesTableV3-headerLeft">{filterPanel}</div>
					<div className="discoverGamesTableV3-headerRight">{actionButtons}</div>
				</div>
			)}

			{!filtersCollapsed && (
				<div className="discoverGamesTableV3-headerBottom">{actionButtons}</div>
			)}
		</div>
	);
}
